import React, { useCallback, useEffect, useContext, useState } from 'react'
import { MyContext } from '../../context/createContext'
import Background from './background'
import Scores from './content/Scores'
import Text from './content/Text'
import { Board, BoardWrapper, InfoWrapper } from './GameBoardStyles'
import useTrainHandler from './helpers/handleTrainHistory'
import { BOARD_PROPS } from './interface'
import Train from './train/Train'

function ScoreBoard({
  roll,
  autoConfig,
  handleAbove,
  handleRoundId,
  handlePopup,
  sendSocketMessage,
  history,
  isLoaded,
  animate,
  audio,
  win,
  prec,
}: BOARD_PROPS) {
  const { context } = useContext(MyContext)
  const { rollUnder, bet, auth } = context
  const { rolled, bet_id, profit } = bet
  const {
    balance: { currency },
  } = auth

  const { my } = history
  const [lastProfit, lastResult, lastId, trainInfo, anim, showTrain] =
    useTrainHandler(my, bet_id, bet)

  const [rollUnderValue, setRollUnder] = useState<boolean>(rollUnder)

  useEffect(() => {
    if (rollUnder === '1') {
      setRollUnder(false)
    } else if (rollUnder === '0') setRollUnder(true)
    else setRollUnder(rollUnder)
  }, [rollUnder])

  return (
    <BoardWrapper>
      <Background
        rollUnder={!rollUnderValue}
        betId={bet_id}
        win={profit > 0}
        lastProfit={lastProfit}
        animate={animate}
        isLoaded={isLoaded}
      />
      <Board>
        <Scores
          rollUnder={!rollUnderValue}
          roll={roll}
          result={rolled}
          profit={profit}
          currency={currency}
          lastResult={lastResult}
          lastProfit={lastProfit}
          betId={bet_id}
          win={win}
        />
        <InfoWrapper>
          {showTrain ? (
            <Train
              betId={bet_id}
              result={rolled}
              trainInfo={trainInfo}
              handleAbove={handleAbove}
              handleRoundId={handleRoundId}
              handlePopup={handlePopup}
              anim={anim}
              sendSocketMessage={sendSocketMessage}
              audio={audio}
            />
          ) : (
            !autoConfig && <Text />
          )}
        </InfoWrapper>
      </Board>
    </BoardWrapper>
  )
}
export default ScoreBoard
